// eslint-disable-next-line
/* eslint-disable */

let callbacksGlobal = null;

function chunkSizeFuncV2 (fileSize) {

    if ( fileSize >= 50 * 1024 * 1024 ) {
        return 10 * 1024 * 1024
    }

    // if ( fileSize < 100 * 1024 ) {
    //     return fileSize
    // }

    return Math.trunc(fileSize / 10)

}

async function upload(props) {

    const {file, chunkSize, cancelStatus, ProgressDialogVisible, ProgressDialogValue, url, zipFilename, element} = props

    // const totalChunks = Math.trunc (file.size/chunkSize) + 1
    const totalChunks = chunkSize !== 0  ? Math.trunc (file.size/chunkSize) + 1 : 0

    let start = 0
    let end = chunkSize
    let chunkIndex = 0
    const uName = await uniqueName({url})

    const copyProps = {...props, uName, element}


    //callback invoke
    const {beforeUploadFileCallback} = callbacksGlobal
    if (beforeUploadFileCallback !== null && typeof beforeUploadFileCallback === 'function' ) {
        beforeUploadFileCallback(copyProps)
    }


    //показываем модалку ПрогрессБара
    ProgressDialogVisible.value = true

    let fileChunkHash = '';

    while ( start < file.size ) {

        if( cancelStatus.value ) {
            break;
        }

        // console.log('totalChunks = ', totalChunks, Math.trunc (file.size/chunkSize) )
        // console.log('file size = ', file.size, 'chunkIndex', chunkIndex,  'start = ', start, 'end = ', end)

        const resultChunk = await uploadChunk({url, file, start, end, chunkIndex, totalChunks, zipFilename, uniqueName: uName.filename, ProgressDialogValue, fileChunkHash})

        start = end
        end = start + chunkSize
        chunkIndex++

        //считываю хеш чанка
        if(resultChunk['fileChunkHash'] !== undefined) {
            fileChunkHash = resultChunk['fileChunkHash']
        }

        //проверяю значения сверки контрольных значений чанков
        //если значение фалс, то начинаем отмену заливки файлов
        //эта строчка отменяет заливку файла путем изменения глобальной переменной (ссылка на кнопку отмены в прогресс баре)
        //я потратил 3 часа, чтобы понять где я сломал код - оказалось в этом месте надо быть очень осторожным! =)))
        if(resultChunk['fileChunkHashResult'] === false) {
            cancelStatus.value = true
        }


    }

    //скрываем модалку ПрогрессБара
    ProgressDialogVisible.value = false

    //callback invoke
    const {uploadFileCallback} = callbacksGlobal
    if (uploadFileCallback !== null && typeof uploadFileCallback === 'function' ) {
        uploadFileCallback(copyProps)
    }

    return ''

}

async function uploadChunk(props) {

    const {url, file, start, end, chunkIndex, totalChunks, uniqueName, zipFilename, fileChunkHash, ProgressDialogValue} = props

    const copyProps = {...props}
    delete copyProps.file

    const chunk = file.slice(start, end)

    const formData = new FormData()

    formData.append('license', 'none')
    formData.append('formType', 'support-file-upload-v3-multi')
    // formData.append('captchaValue', '1234')
    // formData.append('encCaptchaValue', '1234')
    formData.append('name', file.name)
    formData.append('recommendedFilename', uniqueName)
    formData.append('zipFilename', zipFilename)
    formData.append('index', chunkIndex)
    formData.append('file', chunk)
    formData.append('step', 2)
    formData.append('fileChunkHash', fileChunkHash)

    // if(uniqueName !== '') {
    //     formData.append('uniqueName', uniqueName)
    // }

    // console.log('totalChunks', totalChunks)
    // console.log('chunkIndex',  chunkIndex)

    // if( totalChunks === (chunkIndex+1) ) {
    // console.log('totalChunks === chunkIndex', totalChunks,  chunkIndex)
    if( totalChunks === (chunkIndex + 1) ) {
        copyProps['lastChunk'] = true
        formData.append('lastChunk', true)
        // console.log('lastChunk',  'totalChunks === (chunkIndex+1)')
    }



    let result = {}

    await fetch(url, {
        method: 'POST',
        body: formData
    })
        .then( r => r.json())
        .then( r => {
            result = r
        })
        .catch( r => result = r)

    //callback invoke
    const {uploadChunkCallback} = callbacksGlobal
    if (uploadChunkCallback !== null && typeof uploadChunkCallback === 'function' ) {
        uploadChunkCallback(copyProps)
    }

    return result

}



// function cancelUpload() {}


async function uploadSequenceFiles (props) {

    const {storage, cancelStatus, ProgressDialogVisible, ProgressDialogValue, currentFileNameForProgressDialog, url, zipFilename, callbacks } = props

    callbacksGlobal = callbacks

    currentFileNameForProgressDialog.value = '' //"обнуляю" имя файла перед проходом по циклу

    // console.log('zipFilename', zipFilename)

    //TODO написать реализацию для динамический полей заливки файлов
    //пишут, что forEach не умеет последовательно обрабатывать массив и хочет все делать паралельно
    // поэтому меняю на for
    //https://sentry.io/answers/are-there-any-issues-with-using-async-await-with-foreach-loops-in-javascript/

    // storage.forEach(async (el) => {
    for (const el of storage) {

        //если статус отмены загрузки включен, тогда прекращаем заливку
        if( cancelStatus.value ) {
            break
        }

        //ссылка на сам файл
        const file = el.item

        currentFileNameForProgressDialog.value = file.name //имя текущего файла для прогресс бара

        //расчет минимального размера кусочка файла для заливки
        const chunkSize = chunkSizeFuncV2(file.size)

        //реальное имя файла
        //сохраняем реальное имя файла в накопителе
        el.realFileName = file.name

        // console.log('forEach item.files', file, 'size', chunkSize, 'file', realFileName)
        // console.log('cancelStatus', cancelStatus.value)

        await upload({file, chunkSize, cancelStatus, ProgressDialogVisible, ProgressDialogValue, url, zipFilename, element: el})

    }

    //callback invoke
    const {uploadStorageCallback} = callbacksGlobal
    if (uploadStorageCallback !== null && typeof uploadStorageCallback === 'function' ) {
        uploadStorageCallback(props)
    }

    //здесь я буду отменять результаты отменненной заггруки
    if( cancelStatus.value ) {
        await cancelUpload({storage,  url, zipFilename})
    }

    //надо отправить заключительный пункт для отправки файла
    //все, что должно быть собрано в единый архив и отправит заключительное письмо

    let result = {
        success: false,
        zip: '',
    }

    if( !cancelStatus.value ) {
        result = await finalUploadStep({storage,  url, zipFilename})
    }

    return result

}


async function finalUploadStep(params) {

    const { storage, url, zipFilename } = params

    // console.log('finalUploadStep')
    // console.log('storage', storage)
    // console.log('url', url)
    // console.log('zipFilename', zipFilename)

    const files = storage.filter((el) => el.uploaded && el.valid ).map((el) => ({realFileName: el.realFileName, tempFileName :el.tempFileName}) )
    // console.log('files', files)

    if( !files.length ) {
        return null
    }

    const formData = new FormData()

    formData.append('license', 'none')
    formData.append('formType', 'support-file-upload-v3-multi')
    formData.append('zipFilename', zipFilename)
    formData.append('files', JSON.stringify(files))
    formData.append('step', 3)

    let result = null
    await fetch(url, {
        method: 'POST',
        body: formData
    })
        .then( r => r.json())
        .then( d => {
            result = d
        })
        .catch((d) => {
            result = d
        })

    return result

}


// eslint-disable-next-line
async function cancelUpload (params) {

    const { storage, url, zipFilename } = params
    // console.log('storage', storage)
    // console.log('url', url)
    // console.log('zipFilename', zipFilename)

    const files = storage.map((item) => item.tempFileName).filter((item) => item !== null)

    const formData = new FormData()
    formData.append('license', 'none')
    formData.append('formType', 'support-file-upload-v3-multi')
    formData.append('zipFilename', zipFilename)
    formData.append('files', JSON.stringify(files))
    formData.append('step', -2)

    let result = null
    await fetch(url, {
        method: 'POST',
        body: formData
    })
    .then( r => r.json())
    .then( d => {
        result = d
    })
    .catch((d) => {
        result = d
    })

    // console.log('result', result)

}


async function getCounter(props) {

    const {url} = props

    const formData = new FormData()

    formData.append('license', 'none')
    formData.append('formType', 'support-file-upload-v3-multi')
    formData.append('step', 1)

    let result = null

    await fetch(url, {
        method: 'POST',
        body: formData
    })
        .then( r => r.json())
        .then( r => {
            result = r
        })
        .catch( r => result = r)

    return result

}

async function uniqueName(props) {

    const {url} = props

    const formData = new FormData()

    formData.append('license', 'none')
    formData.append('formType', 'support-file-upload-v3-multi')
    formData.append('step', 0)

    let result = null

    await fetch(url, { method: 'POST', body: formData })
        .then( r => r.json())
        .then( r => {
            result = r
        })
        .catch( r => result = r)

    return result

}


export {uploadSequenceFiles, getCounter}